<template>
  <div class="shortcutMenu">
   <!-- 快捷菜单 -->
   
   <card-plate title="快捷菜单">
     <!-- <span slot="headMore"><span>更多>></span></span> -->
     <div slot="headCont" class="shortcut-tag-cont">
       
      <el-tag
        closable
        v-for="item in menuList"
        :key="item.menuId"
        type="info"
        @close="deleteTag(item)"
        @click="toPath(item.navigationUrl)"
        effect="plain">
        {{ item.navigationName }}
      </el-tag>
      
      <div class="shortcut-add-tag"  @click="addTag"><img src="../../../assets/images/normal.png" alt=""></div>
     </div>
   </card-plate>
   
    <add-tag-dialog :initValue="menuList" @initfuc="initfuc"></add-tag-dialog>
  </div>
</template>
<script>
import Cookies from "js-cookie";
import addTagDialog from "./addTagDialog.vue";
import {mapActions} from 'vuex';
import cardPlate from './cardPlate.vue'
export default {
  props: [],
  components: {
    'card-plate': cardPlate,
    "add-tag-dialog": addTagDialog
  },
  data () {
    return {
      menuList:[]
    }
  },
  mounted () {
    this.findAllDashboardNavs()
  },
  methods: {
    ...mapActions(['setTagDialog']),
    addTag(){
      this.setTagDialog({show:true})
    },
    deleteTag(item){
      // console.info(item)
      this.$confirm('是否删除该导航菜单?', '删除该导航菜单', {
                confirmButtonText: '删除',
                cancelButtonText: '取消',
                // type: 'warning',
                cancelButtonClass:'cancelBtn',
                customClass:'mobileText',
                center: true
            }).then(() => {
                
              this.deleteDashboardNav(item,()=>{
                this.findAllDashboardNavs()
              })
            }).catch(() => {
                
            });
    },
    toPath (url) {
      window.open(url, '_blank')
    },
    initfuc(item){
      // console.info(item)
      this.findAllDashboardNavs()
    },
    setList(data,cb){
      // console.info(data)
      if (data.code == 0) {
        this.$set(this,'menuList',data.data)
      } else {
        this.$message.error(data.errorMsg);
      }
      
    },
    // POST /dashboardNav/findAllDashboardNavs快速导航
    findAllDashboardNavs(cb) {
      this.$axios
        .post(`/onelink.mdata.main.api/dashboardNav/findAllDashboardNavs?userId=${Cookies.get("userId")}`, {
          // userId:Cookies.get("userId")
        })
        .then(res => {
          this.setList(res.data,cb)
        })
        .catch(err => {
          console.log(err);
        });
    },
    // POST /dashboardNav/deleteDashboardNav删除快速导航
    
    deleteDashboardNav(item,cb) {
      this.$axios
        .post(`/onelink.mdata.main.api/dashboardNav/deleteDashboardNav?id=${item.id}`, {
          // userId:Cookies.get("userId")
        })
        .then(res => {
         
          if (res.data.code == 0) {
            cb&&cb()
          } else {
            this.$message.error(data.errorMsg);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
  }
}
</script>
<style>
.shortcutMenu .cardPlate-cont{
  padding: 0;
}
.shortcut-tag-cont{
  padding: 15px 15px 0;
  margin-bottom: 10px;
  max-height: 180px;
  overflow: auto;
}
.shortcut-tag-cont .el-tag:hover,.shortcut-tag-cont .shortcut-add-tag:hover{
  cursor: pointer;
}
.shortcut-tag-cont::-webkit-scrollbar {
  width: 8px;
  height: 10px;
}

.shortcut-tag-cont::-webkit-scrollbar-track {
  background: transparent;
  border-radius: 4px;
}

.shortcut-tag-cont::-webkit-scrollbar-thumb {
  -webkit-border-radius: 4px;
  border-radius: 4px;
  background: rgba(0,0,0,0.3);
}

.shortcut-tag-cont::-webkit-scrollbar-thumb:window-inactive {
  background: rgba(0,0,0,0.2);
}
.shortcut-tag-cont .el-tag{
  margin-bottom: 10px;
  margin-right: 10px;
}
.shortcut-tag-cont .el-tag--info{
  position: relative;
  color:#303133;
  font-size: 12px;
  height: 30px;
  line-height: 30px;
  border: 1px solid #DCDFE6;
  background: #fff;
}
.shortcut-tag-cont .el-tag--info .el-tag__close{
  position:absolute;
  right:-6px;
  top:-6px;
  display: none;
  font-size:8px;
  text-align: center;
  height: 12px;
  line-height: 12px;
  width: 12px;
  background: #C0C4CC;
  color: #fff;
}
.shortcut-tag-cont .el-tag--info:hover{
  background: #F2F8FF;
  border: 1px solid #90BCF2;
  color:#2E8AF1;
}
.shortcut-tag-cont .el-tag--info:hover .el-tag__close{
  display: block;
}
.shortcut-tag-cont .el-tag--info .el-tag__close:hover{
  background:#2E8AF1;
  color: #fff;
}
.shortcut-tag-cont .shortcut-add-tag{
  height: 30px;
  line-height: 30px;
  text-align: center;
  border: 1px dotted #2E8AF1;
  background: #fff;
  color:#2E8AF1;
  display: inline-block;
  padding: 0 10px;
  margin-bottom: 10px;
  border-radius: 4px;
}
.shortcut-tag-cont .shortcut-add-tag:hover{
  border: 1px dotted #2E8AF1;
  background: #fff;
  color:#2E8AF1;
}
.shortcut-tag-cont .cardPlate-cont {
    max-height: 265px;
    overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/pages/workBench/components/shortcutMenu.vue